import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FindAPDFiltersModel } from "../../redux/reducers/filters-reducer";
import { updateNumberFilter } from "../../redux/actions/actions";

interface DispatchToProps {
    updateNumberFilter: (filterName: string, filterValue: number) => any;
}

export class FilterDropdownPageSize extends React.Component<DispatchToProps, any> {
    constructor(props: DispatchToProps) {
        super(props);
    }

    dropdownChangeEvent(event) {
        this.props.updateNumberFilter("pageSize", event.target.value);
    }

    render() {
        return (
            <div className="find-a-pd-filters-panel-item">
                <label htmlFor="pageSize">Results to Display</label>
                <div className="find-a-pd-filters-option">
                    <select id="pageSize" defaultValue="Results to Display" onChange={this.dropdownChangeEvent.bind(this)} >
                        <option>10</option>
                        <option>25</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDFiltersModel>): DispatchToProps {
    return {
        updateNumberFilter: (filterName: string, filterValue: number) => dispatch(updateNumberFilter(filterName, filterValue))
    }
}

export default connect(null, mapDispatchToProps)(FilterDropdownPageSize);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filter-dropdown-page-size.tsx